// test1284
(1284 && 0);
